module.exports = __webpack_public_path__ + "static/media/gray.cdcb1782.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/dummy-images/poly/gray.jpeg
// module id = ./src/CSS/assets-minified/dummy-images/poly/gray.jpeg
// module chunks = 0